import { useEffect } from 'react';

import { useCustomTestCreateWizard } from 'pages/custom_tests_v1/components/custom_test_create_wizard/context';
import { QuestionPicker } from 'pages/custom_tests_v1/components/question_picker/QuestionPicker';
import { GMetrixCheckInput } from 'components/GMetrixCheckInput/GMetrixCheckInput';
import { GMetrixInput } from 'components/GMetrixInput/GMetrixInput';
import { Form } from 'react-bootstrap';
import { useIntl } from 'react-intl';

export const QuestionSelectStep = () => {

    const { fetchQuestions, handleQuestionsChange, loadingQuestions: loading, questionTree, randomly, selectedQuestions,
        setProviderState, useRandomly } = useCustomTestCreateWizard();
    const { formatMessage } = useIntl();

    const handleUseRandomlyChange = e => setProviderState({ useRandomly: e.target.checked });

    const handleRandomlyChange = e => setProviderState({ randomly: parseInt(e.target.value, 10) || 0 });

    useEffect(() => {

        fetchQuestions();

    }, []);

    return (
        <div className="d-flex flex-column gap-3">
            <QuestionPicker
                loading={loading}
                onChange={handleQuestionsChange}
                questionTree={questionTree}
            />

            <div>
                <GMetrixCheckInput
                    checked={useRandomly}
                    label={formatMessage({ id: 'randomize_questions.26374601', defaultMessage: 'Randomize Questions' })}
                    onChange={handleUseRandomlyChange}
                    type="checkbox"
                />

                {useRandomly && (
                    <div className="mt-2">
                        <GMetrixInput
                            label={formatMessage({ id: 'number_of_random_questions_to_show.cdd6ff9a', defaultMessage: 'Number of random questions to show' })}
                            max={selectedQuestions > 0 ? selectedQuestions : undefined}
                            min={1}
                            onChange={handleRandomlyChange}
                            type="number"
                            value={randomly.toString()}
                        />
                        {selectedQuestions > 0 && (
                            <Form.Text className="text-muted">
                                {`${formatMessage({ id: 'total_questions_selected.bcbc4913', defaultMessage: 'Total questions selected' })}: ${selectedQuestions}`}
                            </Form.Text>
                        )}
                    </div>
                )}
            </div>
        </div>
    );

};
